import ApiService from './ApiService';

export default class SeoApi extends ApiService {
    constructor() {
        super('seo');
    }

    getSeoCms({ type, entityId }) {
        return this.get(`${type}/${entityId}`);
    }

    updateSeoCms({ type, entityId, payload }) {
        return this.put(`${type}/${entityId}`, payload);
    }

    getPresignedUrl(payload) {
        return this.post('upload/presigned-url', payload);
    }
}
